module.exports = __webpack_public_path__ + "static/media/RoughTrax.2f140c85.png";